import React from "react";
import { Button, Card, CardContent, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import AnimatedChartPreview from "../components/AnimatedChartPreview";
import NewsSummaryCard from "../components/NewsSummaryCard";

function HomePage() {
  const navigate = useNavigate();

  return (
    <div className="bg-gray-50 min-h-screen">
      {/* Hero */}
      <div className="bg-gradient-to-br from-indigo-900 to-blue-600 text-white py-20 px-6 md:px-20 text-center">
        <h1 className="text-4xl md:text-6xl font-bold mb-4">Empower Your Investments</h1>
        <p className="text-lg md:text-xl mb-6">
          Discover trends. Visualize growth. Build conviction.
        </p>
        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={() => navigate("/dashboard")}
        >
          Launch Dashboard
        </Button>
      </div>

      {/* Chart Animation Section */}
      <div className="py-16 px-6 md:px-20 text-center">
        <h2 className="text-3xl font-bold mb-6">Live Investment Insights</h2>
        <AnimatedChartPreview />
      </div>

      {/* CTA */}
      <div className="bg-indigo-800 text-white py-12 px-6 md:px-20 text-center">
        <h2 className="text-3xl font-bold mb-4">Start Making Smarter Decisions</h2>
        <p className="mb-6 text-lg">Explore company trends in seconds.</p>
        <Button
          variant="outlined"
          color="inherit"
          size="large"
          onClick={() => navigate("/dashboard")}
        >
          Go to Dashboard
        </Button>
      </div>

      <Card sx={{ mt: 3 }}>
        <CardContent>
          <NewsSummaryCard entity="AAPL" />
        </CardContent>
      </Card>
      
      {/* Footer */}
      <footer className="bg-gray-900 text-gray-300 text-center py-6 text-sm">
        &copy; {new Date().getFullYear()} ... — Built for investors.
      </footer>
    </div>
  );
}

export default HomePage;
